import React from 'react'

import PropTypes from 'prop-types'
import { Box, Card, Divider, Typography } from '@material-ui/core'
import { Watch as WatchIcon } from 'react-feather'

import { ChipProgressStatus } from 'views/ThirdPartyManagements/components'
import { Actions, QuestionnaireList } from './components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

import helpers from 'helpers'
import constants from 'constants/index'
import useStyles from './styles'

const AuditCard = ({ audit, auditsCount, progressStatusId }) => {
  const { companySupplier } = useThirdPartyManagementStepper()

  const { PENDING_PROGRESS_STATUS, INACTIVE_STATUS } =
    constants.companySuppliers

  const progressStatus = audit?.progressStatus || PENDING_PROGRESS_STATUS
  const isInactive = audit?.status === INACTIVE_STATUS

  const classes = useStyles()

  const questionnaires = audit?.companySupplierQuestionnaires || []

  return (
    <Card className={classes.card}>
      <Box className={classes.header}>
        <Box className={classes.titleContainer}>
          <Typography variant="h5" noWrap>
            #{audit?.id} - Avaliação de Conformidade
          </Typography>
        </Box>
        <ChipProgressStatus
          id={progressStatusId}
          progressStatus={progressStatus}
          isInactive={isInactive}
        />
        <Actions
          companySupplierId={companySupplier?.id}
          audit={audit}
          auditsCount={auditsCount}
        />
      </Box>

      <Divider />

      <Box className={classes.dateRow}>
        <Box className={classes.dateBoxLight}>
          <WatchIcon size={18} />
          <Box>
            <Typography variant="caption" display="block">
              Início
            </Typography>
            <Typography variant="body2">
              <strong>
                {helpers.formatters.date(audit?.dateToSendEmails) || '-'}
              </strong>
            </Typography>
          </Box>
        </Box>

        <Box className={classes.dateBoxDark}>
          <WatchIcon size={18} />
          <Box>
            <Typography variant="caption" display="block">
              Fim
            </Typography>
            <Typography variant="body2">
              <strong>{helpers.formatters.date(audit?.endDate) || '-'}</strong>
            </Typography>
          </Box>
        </Box>
      </Box>

      <QuestionnaireList questionnaires={questionnaires} />
    </Card>
  )
}

AuditCard.propTypes = {
  audit: PropTypes.object,
  auditsCount: PropTypes.number,
  progressStatusId: PropTypes.string,
}

AuditCard.defaultProps = {
  audit: {},
}

export default AuditCard
